import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { JVDate } from "../../shared/JVDate";
import { JVDropdown } from "../../shared/JVDropdown";
import { IECIStatusDropdown, ITimeZoneDropdown } from "../../models/IDropdown";
import { JVTime } from "../../shared/JVTime";
import { format } from 'date-fns';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { RadioButton } from "primereact/radiobutton";
import { JVSunEditor } from "../../shared/JVSuneditor";
import { ECIType } from "../../models/FDropdown";
import { IEmailTemplate } from "../../models/EmailTemplate";
import { ISignatureMast } from "../../models/SignatureMast";

export interface IBenchInterview {
    interview_ID?: number,
    consultant_ID?: number,
    consultant_Name?: string,
    submission_ID?: number,
    interview_Date?: Date,
    interview_Time?: string | Date,
    zone_ID?: number,
    time_Zone_Name?: string,
    interview_Type?: string,
    interviewrName?: string,
    interview_Client?: string,
    interview_Status?: string,
    interview_Comments?: string,
    email_Subject?: string,
    email_Body?: string,
    email_signature?: string
}

const schema = yup.object({
    consultant_ID: yup.number().min(1, "Consultant is required").required("Consultant is required"),
    // submission_ID: yup.number().min(1, "Select Submission").required("Select Submission"),
    interview_Date: yup.date().required("Interview Date is required").typeError("Interview Date is required"),
    interview_Time: yup.date().required("Interview Time is required").typeError("Interview Time is required"),
    zone_ID: yup.number().min(1, "Zone is required").required("Zone is required"),
    interview_Type: yup.string().required("Interview Type is required"),
    interview_Client: yup.string().nullable(),
    interviewrName: yup.string().nullable(),
    interview_Status: yup.string().required("Interview Status is required"),
    interview_Comments: yup.string(),
    email_Subject: yup.string().required("Email Subject is required")
});

interface Iprops {
    singleData: IBenchInterview
    open: boolean,
    hideDialog: () => void,
    toast: any,
    onHide?: () => void,
    reload?: boolean,
    setReload?: (is: boolean) => void
}

export const Interview = (props: Iprops) => {
    const [loading, setLoading] = useState(false);
    const [selectedSubm, setSelectedSubm] = useState(0);
    const [submissionsList, setSubmissionsList] = useState<Array<any>>([]);
    const [timeZome, setTimeZone] = useState<ITimeZoneDropdown[]>();
    const [ecIStatus, setEciStatus] = useState<IECIStatusDropdown[]>([]);
    const [signature, setSignature] = useState("");
    const [signatureDisable, setSignatureDisable] = useState(true);
    const [mailBody, setMailBody] = useState("");
    const [consultants, setConsultants] = useState<Array<{ consultant_ID: number, consultant_Name: string }>>();

    const { control, handleSubmit, formState: { errors }, reset, watch, setValue } = useForm<IBenchInterview>({
        resolver: yupResolver(schema),
        defaultValues: {},
        shouldFocusError: false
    });

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "consultant_ID" && value.consultant_ID) {
                loadTableData(value.consultant_ID);
            }
        });
        return () => subscription.unsubscribe();
    }, [watch]);

    const loadTableData = async (consultant_ID: number) => {
        setLoading(true);
        if (props.singleData.interview_ID) { } else { setSelectedSubm(0); }
        const response = await Fetch("Consultant_Bench/submission", "GET", null, `consultant_ID=${consultant_ID}`, props.toast);
        if (response) {
            const data: Array<any> = await response.json();
            if (props.singleData.interview_ID) {
                setSubmissionsList(data.filter(d => d.submission_ID === props.singleData.submission_ID));
                console.log(data, props.singleData);
            } else {
                setSubmissionsList(data);
                if (data.length === 0) props.toast.current.show({ severity: 'error', content: "End Client Submission not found." });
            }
        }
        setLoading(false);
    }

    useEffect(() => {
        loadConsultants();
        loadStatus();
        loadTimeZone();
        loadSignature();
    }, []);

    useEffect(() => {
        reset(props.singleData);
        if (props.singleData.consultant_ID && props.singleData.submission_ID) {
            setSelectedSubm(props.singleData.submission_ID);
            loadTableData(props.singleData.consultant_ID);
            if (props.singleData.interview_Date)
                setValue("interview_Date", new Date(props.singleData.interview_Date));
            if (typeof (props.singleData.interview_Time) === "string") {
                let timeArray = props.singleData.interview_Time.split(" ");
                let hour = parseInt(timeArray[0].split(":")[0]);
                if (timeArray[1] === "PM") hour += 12;
                let minute = parseInt(timeArray[0].split(":")[1]);
                setValue("interview_Time", new Date(0, 0, 0, hour, minute, 0));
            }
            setValue("interview_Comments", "");
        }
    }, [props.singleData.interview_ID]);

    const generateMail = async () => {
        if (!errors.interview_Date && !errors.interview_Time && !errors.zone_ID && !errors.interview_Status) {
            const _timeZone = timeZome?.find(tz => tz.timezone_ID === control._formValues.zone_ID);
            const _eciStatus = control._formValues.interview_Status;

            const response = await Fetch("Email_Template/byName", "GET", null, `name=${"Bench-" + _eciStatus}`, props.toast);
            if (response) {
                const data: IEmailTemplate = await response.json();
                if (data.template_Subject) setValue("email_Subject", data.template_Subject);

                const table = `<table>
            <thead>
                <th bgcolor="#f2f2f2">ECI Date</th>
                <th bgcolor="#f2f2f2">Time & Zone</th>
                <th bgcolor="#f2f2f2">Status</th>
            </thead>
            <tbody>
                <td bgcolor="#ebebeb">${format(new Date(control._formValues.interview_Date), 'dd/MM/yyyy').toUpperCase()}</td>
                <td bgcolor="#ebebeb">${format(new Date(control._formValues.interview_Time), 'hh:mm a').toUpperCase()} ${_timeZone?.time_Zone_Name}</td>
                <td bgcolor="#ebebeb">${_eciStatus}</td>
            </tbody>
        </table>`;

                // data.template_Body = data.template_Body ? data.template_Body.replace("@salesUserName", props.tableData?.salesmanager ? props.tableData?.salesmanager : "") : "";
                // data.template_Body = data.template_Body.replace("@salesBranchName", props.tableData?.salesBranchName ? props.tableData?.salesBranchName : "");
                // data.template_Body = data.template_Body.replace("@recruiterName", props.tableData?.user_Name ? props.tableData?.user_Name : "");
                // data.template_Body = data.template_Body.replace("@recruiterBranchName", props.tableData?.recruiterBranchName ? props.tableData?.recruiterBranchName : "");
                // data.template_Body = data.template_Body.replace("@consultantName", props.tableData?.consultant_Name ? props.tableData?.consultant_Name : "");
                setMailBody(data.template_Body + table);
            }
        } else props.toast.current.show({ severity: 'error', detail: "first fill all the above required details.", life: 3000 });
    };

    const loadSignature = async () => {
        const response = await Fetch("Signature_Mast", "GET", null, null, props.toast);
        if (response) {
            const data: ISignatureMast = await response.json();
            if (data.signature) setSignature(data.signature);
        }
    }
    const loadStatus = async () => {
        const response = await Fetch("Dropdown/ecI_status", "GET", null, null, null);
        if (response) {
            const data: Array<IECIStatusDropdown> = await response.json();
            setEciStatus(data);
        }
    };
    const loadTimeZone = async () => {
        const response = await Fetch("Dropdown/timezone", "GET", null, null, null);
        if (response) {
            const data: Array<ITimeZoneDropdown> = await response.json();
            setTimeZone(data);
        }
    }
    const loadConsultants = async () => {
        const response = await Fetch("Consultant_Bench/me", "GET", null, null, null);
        if (response) {
            const data = await response.json();
            setConsultants(data);
        }
    };

    const saveToDB = async (body: IBenchInterview) => {
        setLoading(true);

        const method = props.singleData?.interview_ID ? "PUT" : "POST";
        const message = props.singleData?.interview_ID ? "Updated Successfully" : "Added Successfully";

        body.submission_ID = selectedSubm;
        body.email_Body = mailBody;
        body.email_signature = signature;
        const response = await Fetch("Consultant_Bench/eci", method, body, null, props.toast);

        if (response) {
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            onHide();
            if (props.onHide) props.onHide();
            if (props.setReload) props.setReload(!props.reload);
        }
        setLoading(false);
    }

    const onHide = () => {
        props.hideDialog();
        reset();
        setSelectedSubm(0);
        setSubmissionsList([]);
    }

    function onSubmit(data: IBenchInterview) {
        if (data.interview_Time !== null && data.interview_Time !== undefined) data.interview_Time = format(new Date(data.interview_Time), 'hh:mm a').toUpperCase();
        if (mailBody.length < 1) props.toast.current.show({ severity: 'error', content: "Email Body is Required." });
        else if (props.singleData.interview_ID) {
            saveToDB(data);
        } else {
            if (!selectedSubm) props.toast.current.show({ severity: 'error', content: "Select Client Submission." });
            else saveToDB(data);
        }
    }

    const radioBodyTemplate = (rowData: { submission_ID: number, consultant_Name: string }) => {
        return (
            <RadioButton inputId={rowData.submission_ID.toString()} name={rowData.consultant_Name} value={rowData.submission_ID} onChange={(e) => setSelectedSubm(e.value)} checked={selectedSubm === rowData.submission_ID} />
        );
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Bench ECI" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

                <JVDropdown disabled={props.singleData.interview_ID ? true : false} column={2} label="Consultant" required control={control} name="consultant_ID" optionLabel="consultant_Name"
                    optionValue="consultant_ID" options={consultants} placeholder="Select Consultant" error={errors.consultant_ID?.message} />
                <div className="field col-12 md:col-6"></div>

                {submissionsList.length > 0 && <DataTable className="field col-12 md:col-12" style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                    size="small" value={submissionsList} showGridlines
                >
                    <Column header="" body={radioBodyTemplate} />
                    <Column field="sales_Manager" header="Sales Manager" />
                    <Column field="consultant_Name" header="Consultant" />
                    <Column field="client" header="Prime Vendor" />
                    <Column field="endClient" header="Client" />
                    <Column field="location" header="Location" />
                    <Column field="rate" header="Rate" />
                    <Column field="interviewMode" header="MOI" />
                    <Column field="submissionStatus" header="Submission Status" />
                </DataTable>}

                <JVDate column={3} label="Interview Date" required control={control} name="interview_Date" error={errors.interview_Date?.message} />
                <JVTime column={3} label="Interview Time" required control={control} name="interview_Time" error={errors.interview_Time?.message} />

                <JVDropdown column={3} label="Zone" required control={control} name="zone_ID" optionLabel="time_Zone_Name"
                    optionValue="timezone_ID" options={timeZome} placeholder="Select Time Zone" error={errors.zone_ID?.message} />

                <JVDropdown column={3} label="Type" required control={control} name="interview_Type" optionLabel="name" optionValue="name"
                    options={ECIType} placeholder="Select Interview Type" error={errors.interview_Type?.message} />
                <JVInput column={3} label="Client" control={control} name="interview_Client" />
                <JVInput column={3} label="Interviewer Name" control={control} name="interviewrName" error={errors.interviewrName?.message} />

                <JVDropdown column={3} label="Interview Status" required control={control} name="interview_Status" optionLabel="ecI_Type_Name"
                    optionValue="ecI_Type_Name" options={props.singleData.interview_ID ? ecIStatus.filter(d => d.ecI_Type_ID !== 1) : ecIStatus.filter(d => d.ecI_Type_ID === 1)} placeholder="Select Status" error={errors.interview_Status?.message} />

                <JVInput column={3} label="Comments" control={control} name="interview_Comments" error={errors.interview_Comments?.message} />

                <JVInput column={1} label="Email Subject" control={control} name="email_Subject" error={errors.email_Subject?.message} />
                <div className="col-12 md:col-12 md:col-12">
                    <div style={{ display: 'flex', justifyContent: "space-between", alignItems: "flex-end" }}>
                        <label>Email Body</label>
                        <div className="m-1">
                            <Button label="Fill Email Body" type="button" icon="pi pi-envelope" className="p-button p-button-danger" onClick={generateMail} />
                        </div>
                    </div>
                    <JVSunEditor value={mailBody} handleChange={setMailBody} />
                </div>

                <div className="col-12 md:col-12 md:col-12">
                    <div style={{ display: 'flex', justifyContent: "space-between", alignItems: "flex-end" }}>
                        <label>Signature</label>
                        <div className="m-1">
                            <Button type="button" icon="pi pi-pencil" className="p-button-rounded p-button-text" onClick={() => setSignatureDisable(!signatureDisable)} />
                        </div>
                    </div>
                    <JVSunEditor value={signature} handleChange={setSignature} disable={signatureDisable} />
                </div>


                <div style={{ margin: '10px 0', width: '100%' }}></div>
                <div className="field col-12 md:col-12">
                    <Button className="field col-12 md:col-6" loading={loading} label="SAVE" type="submit"></Button>
                    <Button className="className=field col-12 md:col-6 p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                </div>
            </form>
        </Dialog>
    );
}
